import { render, staticRenderFns } from "./OnlineCarInsurance.vue?vue&type=template&id=b55f9a62"
import script from "./OnlineCarInsurance.vue?vue&type=script&lang=ts"
export * from "./OnlineCarInsurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports